import { createRef, h } from "preact";

import TextField from "../TextField.jsx";
import { useEffect, useLayoutEffect, useState } from "preact/hooks";
import { classNames } from "../../helpers.js";

function createSuggestions(props) {
  return props.options.suggestions
    .map(([text, _normalized]) => text)
    .reduce((memo, text) => ({ ...memo, [text]: null }));
}

export default function FreeText(props) {
  const [suggestions, setSuggestions] = useState([]);
  const [hasSuggestions, setHasSuggestions] = useState(false);
  const [value, setValue] = useState(props.answer);
  const [disabled, setDisabled] = useState(false);
  const ref = createRef();

  function handleChange(event) {
    const newValue = event.target.value;
    if (value === newValue) {
      return;
    }
    props.onSelect(newValue);
    setValue(newValue);
  }

  useEffect(() => {
    setDisabled(props.disabled);
  }, [props.disabled]);

  useEffect(() => {
    if (props.options.suggestions && props.options.suggestions.length > 0) {
      setSuggestions(createSuggestions(props));
      setHasSuggestions(true);
    }
  }, []);

  useLayoutEffect(() => {
    if (hasSuggestions && ref.current) {
      M.Autocomplete.init(ref.current.querySelector("input"), {
        data: suggestions,
      });
    }
  }, []);

  return (
    <div class="mb-32" ref={ref}>
      <TextField
        id="question-suggested"
        name="answer"
        class={hasSuggestions ? "autocomplete" : ""}
        value={value}
        info={props.options.helperText}
        disabled={disabled}
        error={props.error}
        errorBorder={props.errorBorder}
        label={props.options.label}
        onChange={handleChange}
        onUpdate={props.onUpdate}
        autocomplete={hasSuggestions ? "off" : ""}
      />
    </div>
  );
}
